<template>
  <div class="time-frame">
    <el-form label-width="120" label-position="left">
      <div class="out-timebox flex flex-between">
        <!-- <div class="timebox">
          <el-button @click="active=0" :type="active==0?'primary':''">今日報告</el-button>
        </div>
        <div class="timebox">
          <el-button @click="active=1" :type="active==1?'primary':''">本月報告</el-button>
        </div>
        <div class="timebox">
          <el-button @click="active=2" :type="active==2?'primary':''">今年報告</el-button>
        </div> -->
        <div class="timebox">
          <el-button @click="active=3" :type="active==3?'primary':''">1月1月 - 3月31</el-button>
        </div>
        <div class="timebox">
          <el-button @click="active=4" :type="active==4?'primary':''">4月1月 - 6月30</el-button>
        </div>
        <div class="timebox">
          <el-button @click="active=5" :type="active==5?'primary':''">7月1月 - 9月30</el-button>
        </div>
        <div class="timebox">
          <el-button @click="active=6" :type="active==6?'primary':''">10月1月 - 12月31</el-button>
        </div>
      </div>
      <div class="flex-between-center">
        <div style="width:100%">
          <el-date-picker v-model="form.starttime" type="datetime" placeholder="自定義開始日期" style="width:100%">
          </el-date-picker>
        </div>
        <div class="mr15 ml15">-</div>
        <div style="width:100%">
          <el-date-picker v-model="form.endtime" type="datetime" placeholder="自定義結束時間" style="width:100%">
          </el-date-picker>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'timeFrame',
  props: ['form'],
  data () {
    return {
      active: 0,
    }
  },
  created () {
    let myDate = new Date();
    let currentMonth = myDate.getMonth() + 1;
    if (currentMonth <= 3) {
      this.active = 3;
    } else if (currentMonth <= 6) {
      this.active = 4;
    } else if (currentMonth <= 9) {
      this.active = 5;
    } else {
      this.active = 6;
    }
  },
  watch: {
    active (val) {
      let myDate = new Date();
      let currentDay = myDate.toLocaleDateString();
      let currentYear = myDate.getFullYear();
      let currentMonth = myDate.getMonth() + 1;
      if (val == 0) {
        this.form.starttime = currentDay;
        this.form.endtime = currentDay;
      } else if (val == 1) {
        this.form.starttime = `${currentYear}-${currentMonth}-01 00:00:00`;
        this.form.endtime = currentDay;
      } else if (val == 2) {
        this.form.starttime = `${currentYear}-01-01 00:00:00`;
        this.form.endtime = currentDay;
      } else if (val == 3) {
        this.form.starttime = `${currentYear}-01-01 00:00:00`;
        this.form.endtime = `${currentYear}-03-31 23:59:59`;
      } else if (val == 4) {
        this.form.starttime = `${currentYear}-04-01 00:00:00`;
        this.form.endtime = `${currentYear}-06-30 23:59:59`;
      } else if (val == 5) {
        this.form.starttime = `${currentYear}-07-01 00:00:00`;
        this.form.endtime = `${currentYear}-09-30 23:59:59`;
      } else if (val == 6) {
        this.form.starttime = `${currentYear}-10-01 00:00:00`;
        this.form.endtime = `${currentYear}-12-30 23:59:59`;
      }
    },
    'form.starttime' (val) {
      let endtime = this.form.endtime;
      // console.log(endtime);
      if (val == '2020-01-01 00:00:00' && endtime == '2020-03-31 23:59:59') {
        this.active = 3;
      } else if (val == '2020-04-01 00:00:00' && endtime == '2020-06-30 23:59:59') {
        this.active = 4;
      } else if (val == '2020-07-01 00:00:00' && endtime == '2020-09-30 23:59:59') {
        this.active = 5;
      } else if (val == '2020-10-01 00:00:00' && endtime == '2020-12-30 23:59:59') {
        this.active = 6;
      } else {
        this.active = -1;
      }
    },
    'form.endtime' (val) {
      let endtime = val;
      let starttime = this.form.starttime;
      if (starttime == '2020-01-01 00:00:00' && endtime == '2020-03-31 23:59:59') {
        this.active = 3;
      } else if (starttime == '2020-04-01 00:00:00' && endtime == '2020-06-30 23:59:59') {
        this.active = 4;
      } else if (starttime == '2020-07-01 00:00:00' && endtime == '2020-09-30 23:59:59') {
        this.active = 5;
      } else if (starttime == '2020-10-01 00:00:00' && endtime == '2020-12-30 23:59:59') {
        this.active = 6;
      } else {
        this.active = -1;
      }
    }
  }

}
</script>

<style  scoped>
.flex{
  display:flex;
}
.flex-between{
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.item-flex1{
  flex:1;
}

.item-flex2{
  flex:2;
}

.item-flex3{
  flex:3;
}

.time-frame {
  overflow: hidden;
}
.out-timebox {
  margin-right: -15px;
}
.timebox {
  flex: 1;
  margin-bottom: 15px;
  margin-right: 15px;
}
.timebox button {
  width: 100%;
}
.mr15 {
  margin-right: 15px;
}
.ml15 {
  margin-left: 15px;
}
.flex-between-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>